export class CustomerError extends Error {
    type: CustomerErrorType;

    constructor(type: CustomerErrorType, message?: string) {
        super(message ?? CustomerErrorMessages[type]);

        this.type = type;
    }
}

export enum CustomerErrorType {
    EmailAlreadyTaken = 'EmailAlreadyTaken',
    PhoneAlreadyTaken = 'PhoneAlreadyTaken',
    Unknown = 'Unknown'
}

export const CustomerErrorMessages: Record<CustomerErrorType, string> = {
    [CustomerErrorType.EmailAlreadyTaken]: 'This email is already taken.',
    [CustomerErrorType.PhoneAlreadyTaken]: 'This phone number is already taken.',
    [CustomerErrorType.Unknown]: 'Oops, something went wrong.'
};
